export const getLocalToken = () => localStorage.getItem('token');

export const saveLocalToken = (token: string) => localStorage.setItem('token', token);

export const removeLocalToken = () => localStorage.removeItem('token');

export const getWZFilters = (employee: any) => localStorage.getItem(`wz_filters-${employee}`);

export const saveWZFilters = (employee: any, val: any) => localStorage.setItem(`wz_filters-${employee}`, val);

export const removeWZFilters = (employee: any) => localStorage.removeItem(`wz_filters-${employee}`);
